export var focusCapture = 'Wbcg-';
export var expandIconCircle = '$_1F6hc';
export var expandIconRotated = '_2Xk6j';